const map = require('lodash/fp/map');
const memoizer = require('../request-handler/utils/memoizer');

function serviceFactory({ api }) {
  const showUserBanner = memoizer()((inputs, metaData) =>
    api.showUserBanner(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  );

  const saveUserSeenBanner = memoizer()((inputs, metaData) =>
    api.saveUserSeenBanner(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  );

  const getEligiblePfList = memoizer()((inputs, metaData) =>
    api.getEligiblePfList(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  );

  const getEligibleClientList = memoizer()((inputs, metaData) =>
    api.getEligibleClientList(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  );

  const getDocumentTypeList = memoizer()((inputs, metaData) =>
    api.getDocumentTypeList(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  );

  const getDocumentListForAdmin = memoizer()((inputs, metaData) =>
    api.getDocumentListForAdmin(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  );

  const manageUserDocument = memoizer()((inputs, metaData) =>
    api.manageUserDocument(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  );

  const saveClientSub = memoizer()((inputs, metaData) =>
    api.saveClientSub(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  );

  const getClientSub = memoizer()((inputs, metaData) =>
    api.getClientSub(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  );

  const getDocumentList = (inputs, metaData) => {
    return api.getDocumentList(inputs, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  };

  const getAcceptView = (inputs, metaData) => {
    return api.getAcceptView(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  };

  const getActionAccept = (inputs, metaData) => {
    return api.getActionAccept(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  };

  const getDocuSignWebURL = (inputs, metaData) => {
    return api.getDocuSignWebURL(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  };

  const completeDocumentSign = (inputs, metaData) => {
    return api.completeDocumentSign(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  };

  const getSignedDocument = (inputs, metaData) => {
    return api.getSignedDocument(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  };

  const getRmTeamList = memoizer()((inputs, metaData) =>
    api.getRmTeamList(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  );
  
  const searchRmName = memoizer()((inputs, metaData) =>
    api.searchRmName(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  );

  const searchClientName = memoizer()((inputs, metaData) =>
    api.searchClientName(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  );

  const searchOrderId = memoizer()((inputs, metaData) =>
    api.searchOrderId(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  );

  const searchDocumentName = memoizer()((inputs, metaData) =>
    api.searchDocumentName(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  );

  return {
    // Client related endpoints
    saveUserSeenBanner,
    showUserBanner,
    saveClientSub,
    getClientSub,
    getDocumentList,
    getAcceptView,
    getActionAccept,
    getDocuSignWebURL,
    completeDocumentSign,
    getSignedDocument,
    // Client admin related endpoints (RM, CA, SA)
    getEligiblePfList,
    getEligibleClientList,
    getDocumentTypeList,
    getDocumentListForAdmin,
    manageUserDocument,
    getRmTeamList,
    searchRmName,
    searchClientName,
    searchOrderId,
    searchDocumentName
  };

}

module.exports = serviceFactory;
